import { SafeHtml } from '@angular/platform-browser';
import { NotebookCellResource, NotebookResource, SessionResource } from './notebook.resource';
import { NotebookState, NotebookTypes } from '@mode/notebooks/contract';
import { OrderedSet } from 'immutable';
import { NotebookCellRunResultResource } from './notebook.resource';
import { ApiTypes, StateRecord } from '@mode/shared/contract-common';
export enum NotebookVizState {
  Loading = 'loading',
  Empty = 'empty',
  Succeeded = 'succeeded',
  Failed = 'failed',
  Skipped = 'skipped',
}

export interface NotebookVizResult {
  token: string; // viz token
  content: string | SafeHtml;
  result_type: string;
  date: string;
  content_type: string;
}

// for backwards compatibility with python components that expect a type property
export interface NotebookEmbedVizResult extends NotebookVizResult {
  type: string; // content_type alias
}

export interface NotebookVizRender {
  _name: 'pythonVisualization'; // required by VizContainer
  id: string;
  token: string;
  title: string;
  frozen: boolean;
  state: NotebookVizState;
  vizLink: string;
  vizReportRunLink: string;
  results: NotebookEmbedVizResult[];
}

export interface NormalizedNotebookCellExRes {
  readonly token: string;
  readonly content: string;
  readonly content_type: NotebookTypes.ContentType;
  readonly frozen: boolean;
  readonly folded: boolean;
  readonly executing: boolean;
  readonly created_at: Date;
  readonly lastRunToken: string;
  readonly missingRun: boolean;
}

export interface NormalizedNotebookCell extends NormalizedNotebookCellExRes {
  readonly resource: NotebookCellResource;
}

export interface NotebookCellState extends NormalizedNotebookCell {
  readonly isInLayout: boolean;
}

export interface NormalizedNotebookCellRunResultArray {
  readonly tokens: OrderedSet<string>;
  readonly resultTypes: Map<string, string>;
  readonly dates: Map<string, string>;
  readonly contentTypes: Map<string, string>;
  readonly contents: Map<string, string>;
  readonly resources: Map<string, NotebookCellRunResultResource>;
}
export interface NormalizedNotebookCellRunResult extends NotebookVizResult {
  readonly resource: NotebookCellRunResultResource;
}

export interface NormalizedNotebook {
  readonly token: string;
  readonly pusherChannelName: string;
  readonly session: SessionResource;
  readonly resource: NotebookResource;
  readonly initialized: boolean;
  readonly cellTokens: string[];
}

export interface NormalizedNotebooksArray {
  readonly tokens: OrderedSet<string>;
  readonly pusherChannelNames: Map<string, string>;
  readonly sessions: Map<string, SessionResource>;
  readonly resources: Map<string, NotebookResource>;
  readonly initialized: Map<string, boolean>;
  readonly states: Map<string, NotebookState>;
  readonly awaitingInitialRun: Map<string, boolean>;
  readonly notebookTypes: Map<string, NotebookTypes.NotebookType>;

  readonly cellTokensByNotebook: Map<string, OrderedSet<string>>;
}
